import { HttpInterceptorFn } from '@angular/common/http';
import { Injector, inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import {
  AuthService,
  NotificationService,
  SessionExpiredError,
} from '@chefami-monorepo/data-access';
import { SiteText } from '@chefami-monorepo/utils';

// Several requests usually fail together; only the first one redirects.
let isRedirecting = false;

/**
 * Legacy parity: when the session can't be recovered (401 or failed token
 * refresh), show the session toast, clear the session and leave the app.
 * Uses `redirectToLogin()` rather than `logout()`: the logout API would fail
 * with the same dead session and come back through this interceptor.
 */
export const sessionExpiredInterceptor: HttpInterceptorFn = (req, next) => {
  const injector = inject(Injector);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof SessionExpiredError && !isRedirecting) {
        isRedirecting = true;
        // Resolved lazily: AuthService depends on HttpClient, which runs this
        // interceptor, so injecting it up front would be circular.
        void injector.get(NotificationService).error(SiteText.SESSION_ERROR);
        injector.get(AuthService).redirectToLogin();
      }
      return throwError(() => error);
    }),
  );
};
